import Home from './components/Home';
import Stripe3D from './components/payment/Stripe3D';
import Stripe3DReturn from './components/payment/Stripe3DReturn';

const Step0 = resolve => {
  require.ensure(
    ['./components/Step0.vue'],
    () => {
      resolve(require('./components/Step0.vue'));
    },
    'step0'
  );
};

const Step1 = resolve => {
  require.ensure(
    ['./components/Step1.vue'],
    () => {
      resolve(require('./components/Step1.vue'));
    },
    'step1'
  );
};

const Stepper = resolve => {
  require.ensure(
    ['./components/Stepper.vue'],
    () => {
      resolve(require('./components/Stepper.vue'));
    },
    'step1'
  );
};

const Step2 = resolve => {
  require.ensure(['./components/Step2.vue'], () => {
    resolve(require('./components/Step2.vue'));
  });
};

const Step3 = resolve => {
  require.ensure(['./components/Step3.vue'], () => {
    resolve(require('./components/Step3.vue'));
  });
};

const Step4 = resolve => {
  require.ensure(
    ['./components/Step4.vue'],
    () => {
      resolve(require('./components/Step4.vue'));
    },
    'step4'
  );
};

const Step5 = resolve => {
  require.ensure(
    ['./components/Step5.vue'],
    () => {
      resolve(require('./components/Step5.vue'));
    },
    'step5'
  );
};

const PaymentChoice = resolve => {
  require.ensure(
    ['./components/payment/PaymentChoice'],
    () => {
      resolve(require('./components/payment/PaymentChoice'));
    },
    'step4'
  );
};

// const Stripe = resolve => {
//   require.ensure(['./components/payment/Stripe.vue'], () => {
//     resolve(require('./components/payment/Stripe.vue'));
//   });
// };

const Bancontact = resolve => {
  require.ensure(
    ['./components/payment/Bancontact.vue'],
    () => {
      resolve(require('./components/payment/Bancontact.vue'));
    },
    'bc'
  );
};

const BancontactReturn = resolve => {
  require.ensure(
    ['./components/payment/BancontactReturn.vue'],
    () => {
      resolve(require('./components/payment/BancontactReturn.vue'));
    },
    'bc'
  );
};

export const routes = [
  {
    path: '',
    name: 'store-home',
    components: {
      default: Home
    }
  },

  {
    path: '/step0',
    name: 'step0',
    components: {
      default: Step0
    },
    props: {
      default: false
    }
  },

  {
    path: '/step1',
    name: 'step1',
    components: {
      default: Step1,
      'crst-stepper': Stepper
    },
    props: {
      default: false,
      'crst-stepper': { step: 1 }
    }
  },

  {
    path: '/step2',
    name: 'step2',
    components: {
      default: Step2,
      'crst-stepper': Stepper
    },
    props: {
      default: false,
      'crst-stepper': { step: 2 }
    }
  },

  {
    path: '/step3',
    name: 'step3',
    components: {
      default: Step3,
      'crst-stepper': Stepper
    },
    props: {
      default: false,
      'crst-stepper': { step: 3 }
    }
  },

  {
    path: '/step4',
    components: {
      default: Step4,
      'crst-stepper': Stepper
    },
    children: [
      { path: '', component: PaymentChoice },
      //   { path: 'cc', component: Stripe },
      { path: 'bc', component: Bancontact },
      { path: 'stripe3-d', component: Stripe3D },
      { path: 'bcreturn', component: BancontactReturn },
      { path: 'stripe3-dreturn', component: Stripe3DReturn }
    ],
    props: {
      default: false,
      'crst-stepper': { step: 4 }
    }
  },

  {
    path: '/step5',
    name: 'step5',
    components: {
      default: Step5,
      'crst-stepper': Stepper
    },
    props: {
      default: false,
      'crst-stepper': { step: 4 }
    }
  },

  { path: '/redirect-me', redirect: { name: 'store-home' } },
  { path: '*', redirect: '/' }
];



// WEBPACK FOOTER //
// ./src/routes.js